import { TemplateEntityV1beta3 } from '@backstage/plugin-scaffolder-common';
import { TemplateGroupFilter } from '@backstage/plugin-scaffolder-react';

export const createTemplateGroupsWithOther = (
  groups: TemplateGroupFilter[],
  otherTitle: string,
): TemplateGroupFilter[] => [
  ...groups,
  {
    title: otherTitle,
    filter: (entity: TemplateEntityV1beta3) =>
      !groups.some(({ filter }) => filter(entity)),
  },
];
